module.exports = __webpack_public_path__ + "img/vol02_cup01_badge.8a9412d7.png";